<mat-progress-bar class="progress-margin" color="primary" *ngIf="loadingInit" mode="indeterminate"></mat-progress-bar>
<form [formGroup]="formGroup">
    <div class="card-content">
        <div class="card-inline full-width">
            <div>
                <div class="card-inline">
                    <h3 class="card-inline">Valorización </h3>
                    <label  *ngIf="f.ValorizationEdit.errors && f.ValorizationEdit.errors.validValorizationPrincipal"
                    class="alert-message">{{ f.ValorizationEdit.errors.valorizationErrorDescription }}</label>

                    <mat-label class="margin-left-small margin-right-small">{{ getTransactionReferenceMessage() }}</mat-label>
                </div>
                <app-valorization-edit-control
                [isDisabled]="isDisabled"
                [isRegistered]="isRegistered"
                (onRecalculateClick)="recalculate()"
                [loading]="loading || loadingInit"
                formControlName="ValorizationEdit">
                </app-valorization-edit-control>
            </div>
        </div>
    </div>
</form>
